// extracted by mini-css-extract-plugin
module.exports = {"ctn":"Signin_ctn__31aKk","title":"Signin_title__1YpbD","version":"Signin_version__3qzVA"};